import { setFilterData, removeFilterData, resetFilterData } from "../../../constants/model-reducers/external/filter/filter-settings"

const  initialState = {
    filterData: []
}

export const filterActions = {
    setFilterData: (data) => {

        return {
            type: setFilterData,
            payload: data
        }

    },

    removeFilterData: (data) =>{
        return {
            type: removeFilterData,
            payload: data
        }
    },
    resetFilter: () =>{
        return {
            type: resetFilterData,
        }
    }
}


export const reducer  = (state = initialState, action) =>{
    switch(action.type){
        case setFilterData:
            return {
                ...state, 
                filterData: [...state.filterData, ...action.payload]
            };
        case removeFilterData:
            return {
                ...state,
                filterData: state.filterData.filter((item, index) => index !== action.payload)
            };
        case resetFilterData:
            return {
                ...state,
                filterData: []
            };
        default:
            return state
    }
}